import SignInLayout from "@/components/Layouts/SignInLayout";
import SignIn from "@/components/SignIn";
import Head from "next/head";

const Login = () => {
  return (
    <SignInLayout>
      <Head>
        <title>Sign In</title>
      </Head>
      <SignIn />
    </SignInLayout>
  );
};

export default Login;
